import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Dropdown, Input, Form } from 'antd';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';
import { getContents, getPageList, deleteContent, postNewPageContent } from 'data/content';
// import { getContents, getPageList, postNewPageContent, deleteContent } from 'redux/modules/content';
import { loginFacebook, saveFacebookUserData, verify } from 'redux/modules/user';
import Utils from 'utils/utils';

import classes from './styles/Page.module.scss';

const FormItem = Form.Item;
const { TextArea } = Input;
const Confirm = Modal.confirm;

// @asyncConnect([
//   {
//     promise: ({ store: { dispatch } }) => {
//       const promises = [];
//       promises.push(dispatch(getPageList()));
//       promises.push(dispatch(getContents('home')));
//       return Promise.all(promises);
//     },
//   },
// ])
// @

class Page extends Component {
  constructor() {
    super();
    this.onClickRow = this.onClickRow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitNewPage = this.handleSubmitNewPage.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onAddNewPageContent = this.onAddNewPageContent.bind(this);
    this.onAddNewPage = this.onAddNewPage.bind(this);

    this.state = {
      collapseMobile: [],
      showModal: false,
      selectedPage: 'home',
    };
  }
  componentDidMount = async () => {
    const contents = await getContents('home');
    const pages = await getPageList();
    this.setState({
      content: contents,
      pages,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onAddNewPageContent() {
    console.log(this.state.selectedPage);
    this.setState({
      showModal: true,
      selectedRow: {
        pageName: this.state.selectedPage,
      },
      isAddNew: true,
    });
  }

  onAddNewPage() {
    this.setState({
      showNewPageModal: true,
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
    this.setState({
      showModal: true,
      selectedRow: record,
      isAddNew: false,
    });
  }

  onDelete = (record) => {
    // const type = record.subcategories ? 'category' : 'subcategory';
    const self = this;

    deleteContent(record._id).then(async () => {
      const data = await getContents(self.state.selectedPage);
      if (data.length === 0) {
        window.location.reload();
      }
    });
    // }).catch((err) => {
    //   message.error(err.message);
    // });
  };

  changeFocusPage = async (value) => {
    console.log(value);
    const page = value;
    const response = await getContents(page);
    this.setState({
      selectedPage: page,
      content: response,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        console.log(values.value, Utils.isJsonString(values.value));
        if (Utils.isJsonString(values.value)) {
          values.value = JSON.parse(values.value);
        }
        postNewPageContent(values).then(async () => {
          const content = await getContents(values.pageName);
          this.setState({
            showModal: false,
            content,
          });
        });
      }
    });
  }

  handleSubmitNewPage(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        postNewPageContent({
          key: 'sample_name',
          value: 'sample value',
          pageName: values.pageName,
        }).then(async () => {
          const pages = await getPageList();
          this.setState({
            showNewPageModal: false,
            pages,
          });
          this.changeFocusPage(values.pageName);
        });
        console.log('Received values of form: ', values);
      }
    });
  }

  handleCancel() {
    this.setState({
      showModal: false,
      selectedRow: null,
      isAddNew: false,
      confirmDirty: false,
      getFieldDecorator: false,
      showNewPageModal: false,
    });
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  columns = [
    {
      title: 'Name',
      dataIndex: 'key',
      sorter: (a, b) => {
        return a.key.localeCompare(b.key);
      },
      sortOrder: 'ascend',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      render: (text) => {
        if (_.isObject(text) || _.isArray(text)) {
          const newText = JSON.stringify(text);

          return <span>{newText.substring(0, newText.length > 200 ? 200 : newText.length)}</span>;
        }
        const newText = text.toString();
        return <span>{newText.length > 200 ? `${newText.substring(0, 200)}...` : newText}</span>;
      },
    },
    {
      title: '',
      dataIndex: '_id',
      render: (id, record) => (
        <Button
          type="danger"
          onClick={(e) => {
            e.stopPropagation();
            this.showDeleteConfirm(record, `ยืนยันการลบ ${record.key}`);
          }}
        >
          <Icon type="delete" />
        </Button>
      ),
    },
  ];

  renderPageTopMenu() {
    const menus =
      this.state.pages &&
      this.state.pages.map((page) => (
        <Menu.Item key={page} className={cn(classes.dashRight, { [classes.activePageMenu]: page === this.state.selectedPage })}>
          <div>{_.startCase(page)} </div>
        </Menu.Item>
      ));
    console.log(menus);
    return (
      <div className={classes.pageDropdown}>
        <b>Selected Page: </b>
        <Dropdown overlay={<Menu onClick={(selectedMenu) => this.changeFocusPage(selectedMenu.key)}>{menus}</Menu>} selectedKeys={[this.state.selectedPage]} trigger={['click']}>
          <Button style={{ marginLeft: 8 }}>
            {_.startCase(this.state.selectedPage)} <Icon type="down" />
          </Button>
        </Dropdown>
      </div>
    );
  }

  renderAddNewPageModal() {
    const { getFieldDecorator } = this.props.form;
    if (!this.state.showNewPageModal) {
      return <div />;
    }
    return (
      <Modal
        title={'New page'}
        visible={this.state.showNewPageModal}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmitNewPage}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmitNewPage}>
          <FormItem {...formItemLayout} label="Page" hasFeedback>
            {getFieldDecorator('pageName', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderModal() {
    const { getFieldDecorator } = this.props.form;

    if (!this.state.showModal) {
      return <div />;
    }

    const initValue = _.isObject(this.state.selectedRow.value) || _.isArray(this.state.selectedRow.value) ? JSON.stringify(this.state.selectedRow.value) : this.state.selectedRow.value;
    return (
      <Modal
        title={this.state.isAddNew ? 'Add new page content' : `Edit: ${this.state.selectedRow.key}`}
        visible={this.state.showModal}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit} className={classes.modal}>
          <FormItem {...formItemLayout} label="Page" hasFeedback>
            {getFieldDecorator('pageName', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
              initialValue: this.state.selectedRow.pageName,
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Name" hasFeedback>
            {getFieldDecorator('key', {
              rules: [
                {
                  required: true,
                  message: 'Please input Name',
                },
              ],
              initialValue: this.state.selectedRow.key,
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Value" hasFeedback>
            {getFieldDecorator('value', {
              rules: [
                {
                  required: true,
                  message: 'Please input Value',
                },
              ],
              initialValue: initValue,
            })(<TextArea />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('_id', {
              initialValue: this.state.selectedRow._id,
            })(<Input type="hidden" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.content, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    return <Table columns={this.columns} dataSource={content} bordered pagination={{ pageSize: 15 }} onRowClick={this.onClickRow} />;
  }

  render() {
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <div className={cn(classes.addBtnContainer, 'pull-right')}>
            <Button type="primary" onClick={this.onAddNewPageContent}>
              <Icon type="plus" size="large" />
              เพิ่มข้อมูลใหม่
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button type="primary" onClick={this.onAddNewPage}>
              <Icon type="plus" size="large" />
              เพิ่มหน้าใหม่
            </Button>
          </div>
          {this.renderPageTopMenu()}
          {this.renderContentTable()}
          {this.renderModal()}
          {this.renderAddNewPageModal()}
        </div>
      </div>
    );
  }
}

export default connect((state) => ({}), {})(Form.create()(Page));
